/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/ScopePreviewPanel.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ScopePreviewPanelTestIds = {
  btnPreviewRetry: "btn-preview-retry",
  colPreviewIdentity: "col-preview-identity",
  colPreviewProfile: "col-preview-profile",
  colPreviewResource: "col-preview-resource",
  colPreviewRiskLevel: "col-preview-risk-level",
  previewErrorBanner: "preview-error-banner",
  previewFrequencyDisclaimer: "preview-frequency-disclaimer",
  previewInScope: "preview-in-scope",
  previewLoading: "preview-loading",
  previewNoQuery: "preview-no-query",
  previewSampleCaption: "preview-sample-caption",
  previewTooLarge: "preview-too-large",
  previewZeroMatchWarning: "preview-zero-match-warning",
  scopePreviewPanel: "scope-preview-panel",
  tablePreviewResults: "table-preview-results"
} as const;
